import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, MessageCircle } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      id,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  const handleWhatsAppSubmit = () => {
    const text = `Hi Nexora Virtual, I'd like to discuss a project.%0A%0A*Name:* ${formData.name}%0A*Email:* ${formData.email}%0A*Brief:* ${formData.message}`;
    window.open(`https://wa.me/447921876472?text=${text}`, '_blank');
  };
  return <section id="contact" className="py-24 relative overflow-hidden" data-id="element-22">
      {/* Background with subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-white to-[#FFE5D9]/30" data-id="element-23" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-25">
          <div className="grid md:grid-cols-5 h-full" data-id="element-26">
            {/* Left Side - Info */}
            <div className="md:col-span-2 bg-[#1a1a2e] p-10 text-white flex flex-col justify-between relative overflow-hidden" data-id="element-27">
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-[#FF6B35]/20 to-transparent opacity-50" data-id="element-28" />

              <div className="relative z-10" data-id="element-29">
                <h3 className="text-2xl font-bold mb-6" data-id="element-30">
                  Let's Build Something Amazing
                </h3>
                <p className="text-gray-300 mb-8 leading-relaxed" data-id="element-31">
                  Ready to start your project with Nexora Virtual? Fill out the
                  form or contact us directly.
                </p>
              </div>

              <div className="relative z-10 space-y-4 text-sm text-gray-400" data-id="element-32">
                <p className="flex items-center gap-2" data-id="element-33">
                  <span className="font-semibold text-white" data-id="element-34">Email:</span>
                  admin@nexoravirtual.com
                </p>
                <p className="flex items-center gap-2" data-id="element-35">
                  <span className="font-semibold text-white" data-id="element-36">Phone:</span>
                  +44 7921 876472
                </p>
                <p className="flex items-center gap-2" data-id="element-37">
                  <span className="font-semibold text-white" data-id="element-38">Loc:</span>
                  London, UK
                </p>
              </div>
            </div>

            {/* Right Side - Form */}
            <div className="md:col-span-3 p-10 bg-white" data-id="element-39">
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-40">
                <div className="space-y-1" data-id="element-41">
                  <label htmlFor="name" className="text-sm font-bold text-gray-700 ml-1" data-id="element-42">
                    Name
                  </label>
                  <div className="p-[2px] rounded-lg bg-gradient-to-r from-gray-200 to-gray-200 focus-within:from-[#FF6B35] focus-within:to-[#F7931E] transition-all duration-300" data-id="element-43">
                    <input type="text" id="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-md bg-white outline-none text-gray-800 placeholder-gray-400" placeholder="John Doe" data-id="element-44" />
                  </div>
                </div>

                <div className="space-y-1" data-id="element-45">
                  <label htmlFor="email" className="text-sm font-bold text-gray-700 ml-1" data-id="element-46">
                    Email
                  </label>
                  <div className="p-[2px] rounded-lg bg-gradient-to-r from-gray-200 to-gray-200 focus-within:from-[#FF6B35] focus-within:to-[#F7931E] transition-all duration-300" data-id="element-47">
                    <input type="email" id="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-md bg-white outline-none text-gray-800 placeholder-gray-400" placeholder="john@example.com" data-id="element-48" />
                  </div>
                </div>

                <div className="space-y-1" data-id="element-49">
                  <label htmlFor="message" className="text-sm font-bold text-gray-700 ml-1" data-id="element-50">
                    Brief
                  </label>
                  <div className="p-[2px] rounded-lg bg-gradient-to-r from-gray-200 to-gray-200 focus-within:from-[#FF6B35] focus-within:to-[#F7931E] transition-all duration-300" data-id="element-51">
                    <textarea id="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 rounded-md bg-white outline-none text-gray-800 placeholder-gray-400 resize-none" placeholder="Tell us about your project..." data-id="element-52" />
                  </div>
                </div>

                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} type="button" onClick={handleWhatsAppSubmit} className="w-full py-4 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white font-bold rounded-lg shadow-lg shadow-orange-500/30 flex items-center justify-center gap-2 hover:shadow-orange-500/50 transition-all" data-id="element-53">
                  Send via WhatsApp
                  <MessageCircle size={18} data-id="element-54" />
                </motion.button>
              </form>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}